import React from "react";
import { TextArea } from "../../../components";
const UpdateReason = ({
  onClose,
  taskObj,
  isStatusNote,
  setStatusNote,
  errors,
  updateStatus,
}) => {
  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center z-40 bg-black/60">
        <div className="bg-white p-4 rounded-lg shadow-md relative w-auto max-w-xl min-w-[450px]">
          <div className="text-base font-medium !mb-6">
            {taskObj &&
            (taskObj?.record?.["dor.status"] === "inReview" ||
              taskObj?.record?.["dor.status"] === "inProcess" ||
              taskObj?.record?.["dor.status"] === "cancelled" ||
              taskObj?.record?.["dor.status"] === "reOpen")
              ? "Please add a Note"
              : null}
          </div>
          {taskObj &&
            (taskObj?.record?.["dor.status"] === "inReview" ||
              taskObj?.record?.["dor.status"] === "inProcess" ||
              taskObj?.record?.["dor.status"] === "cancelled" ||
              taskObj?.record?.["dor.status"] === "reOpen") && (
              <div className="flex items-center grid grid-cols-1 gap-x-6">
                <TextArea
                  placeholder="Enter a note"
                  className="w-56"
                  value={isStatusNote}
                  onChange={(e) => setStatusNote(e.target.value)}
                />
                {errors?.note_status && (
                  <div className="text-red-500">{errors?.note_status}</div>
                )}
              </div>
            )}
          
          <div className="flex justify-end !mt-4">
            <button
              className="px-4 py-2 mr-2 bg-secondary text-white rounded hover:bg-blue-600"
              onClick={() => {
                updateStatus(taskObj?.record, taskObj?.record?.["dor.status"], isStatusNote);
              }}
            >
              Confirm
            </button>
            <button
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateReason;
